import { act } from "react-dom/cjs/react-dom-test-utils.production.min"
import {
	SEARCH_LOAD_STORAGE,
	SEARCH_DELETE_STORAGE,
	SEARCH_LOAD_ALL_STORAGE_SEARCHS,
	SELECTED_SEARCH,
	REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_LOADER,
	REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_FAILED_OR_SUCCESS_LOADER,
	SAVE_NEW_SEARCH,
	SAVE_NEW_SEARCH_SUCCESS,
	SAVE_NEW_SEARCH_FAILED,
	SAVE_NEW_SEARCH_FAILED_CLEAR,
	DELETE_SEARCH_LOAD,
	DELETE_SEARCH_SUCCESS,
	DELETE_SEARCH_FAILED,
	DELETE_SEARCH_RESET,
} from "../types"

/*const savedSearch= localStorage.getItem('localSearch');
const initValues = () =>{
    try{
        if (savedSearch != null && JSON.parse(savedSearch).searchs.length>0){
          return JSON.parse(savedSearch).searchs;
        }
      }catch(e){
      }
      return [];
}
*/

//cada reducer tiene su propio state
const initialState = {
	savedSearchs: [],
	selectedSearch: undefined,
	loading: false,
	//savedSearchs: initValues(),
	search: {},
	isSaving: false,
	isSaved: false,
	isDeleting: false,
	isDeleted: false,
	deletedId: undefined,
}
function search_array(array, valuetofind) {
	for (let i = 0; i < array.length; i++) {
		if (array[i]["id"] === valuetofind) {
			return i
		}
	}
	return -1
}
// eslint-disable-next-line
export default function (state = initialState, action) {
	switch (action.type) {
		case REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_LOADER:
			return {
				...state,
				loading: true,
			}
		case REQUEST_SEARCH_LOAD_ALL_STORAGE_SEARCHS_FAILED_OR_SUCCESS_LOADER:
			return {
				...state,
				loading: false,
			}
		case SEARCH_LOAD_ALL_STORAGE_SEARCHS:
			return {
				...state,
				savedSearchs: action.payload,
			}
		case SEARCH_LOAD_STORAGE:
			//First check if id exist to overwrite
			let searchIndex = search_array(state.savedSearchs, action.payload.id)
			if (searchIndex === -1) {
				localStorage.setItem("localSearch", JSON.stringify({ searchs: [...state.savedSearchs, action.payload] }))
				return {
					...state,
					savedSearchs: [...state.savedSearchs, action.payload],
				}
			} else {
				let auxSearch = state.savedSearchs
				auxSearch[searchIndex] = action.payload
				localStorage.setItem("localSearch", JSON.stringify({ searchs: auxSearch }))
				return {
					...state,
					savedSearchs: auxSearch,
				}
			}

		case SEARCH_DELETE_STORAGE:
			localStorage.setItem(
				"localSearch",
				JSON.stringify({ searchs: state.savedSearchs.filter((item) => item.id !== action.payload) })
			)
			return {
				...state,
				savedSearchs: state.savedSearchs.filter((item) => item.id !== action.payload),
			}

		case SELECTED_SEARCH:
			return {
				...state,
				selectedSearch: action.payload,
			}
		case SAVE_NEW_SEARCH:
			return {
				...state,
				search: action.payload,
				isSaving: true,
				isSaved: false,
			}
		case SAVE_NEW_SEARCH_SUCCESS:
			return {
				...state,
				search: action.payload,
				isSaving: false,
				isSaved: true,
			}
		case SAVE_NEW_SEARCH_FAILED:
			return {
				...state,
				error: action.payload,
				isSaving: false,
				isSaved: false,
			}
		case SAVE_NEW_SEARCH_FAILED_CLEAR:
			return {
				...state,
				error: undefined,
				isSaving: false,
				isSaved: false,
				search: {},
			}

		case DELETE_SEARCH_LOAD:
			return {
				...state,
				isDeleting: true,
				isDeleted: false,
				deletedId: undefined,
			}
		case DELETE_SEARCH_SUCCESS:
			return {
				...state,
				isDeleting: false,
				isDeleted: true,
				deletedId: action.payload,
			}
		case DELETE_SEARCH_FAILED:
			return {
				...state,
				isDeleting: false,
				isDeleted: false,
				error: action.payload,
			}
		case DELETE_SEARCH_RESET:
			return {
				...state,
				isDeleting: false,
				isDeleted: false,
				deletedId: undefined,
				error: undefined,
			}
		default:
			return state
	}
}
